import { useState } from 'react';
import validator from 'validator';
import { Button, enqueueSnackbar, InputPassword } from '../../design-system';
import { i18n } from '../../i18n';
import { useCreateNewPasswordMutation } from '../../hooks';
import { INPUT_ERRORS, MESSAGES, REGEX } from '../../const';

export const NotificationsForgotPassword = ({ token }: { token: string }) => {
  const [password, setPassword] = useState('');
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const { mutate } = useCreateNewPasswordMutation();

  const validators = {
    password: password
      ? !validator.isLength(password, { min: 8, max: 16 })
        ? INPUT_ERRORS.NOT_VALID.NEW_PASSWORD_LENGTH
        : !REGEX.PASSWORD.test(password)
        ? INPUT_ERRORS.NOT_VALID.NEW_PASSWORD
        : ''
      : isSubmitClicked
      ? INPUT_ERRORS.REQUIRED.NEW_PASSWORD
      : true,
  };

  const handleSubmitClick = () => {
    if (!Object.values(validators).every((isError) => !isError)) {
      if (!isSubmitClicked) setIsSubmitClicked(true);
      return;
    }

    mutate(
      {
        password,
        passwordConfirmation: password,
        token: token,
      },
      {
        onSuccess: (res) => {
          enqueueSnackbar(res.data.message, 'success');
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.AUTH.ERROR.NOT_CHANGED_PASSWORD, 'error');
        },
      },
    );
  };

  return (
    <>
      <InputPassword
        defaultValue={password}
        onChange={(e) => setPassword(e.target.value)}
        label={i18n.t('label.password')}
        placeholder={i18n.t('placeholder.newPassword')}
        data-size={'large'}
        error={(isSubmitClicked && !password) || (!!password && validators.password)}
        helperText={validators.password}
      />
      <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
        {i18n.t('button.resetPassword')}
      </Button>
    </>
  );
};
